import { Button, ChevronLineRight, Column, Icon, Row, Star, Typography } from '@viewup/ui';
import { tipLists } from './ViewupTips.const';

export const ViewupTips = () => {
  return (
    <Column br={12} gap={16} p={20} shadow='center.normal'>
      <Typography fontType='body.medium'>뷰업 꿀팁</Typography>
      <Column gap={8}>
        {tipLists.map((list) => (
          <Button
            key={list.title}
            onClick={() => window.open(list.link, '_blank')}
            rightContent={<Icon color='border.primary' size='3XS' source={ChevronLineRight} />}
            size={'M'}
            styledComponents={{
              root: {
                justifyContent: 'space-between',
                minWidth: 0,
                p: 0,
                width: '100%',
              },
            }}
            variant='ghost.assistive'
          >
            <Row alignItems='center' gap={12}>
              <Row bgColor='bg.disabledLight' br={16} p={8}>
                <Icon size='XS' source={Star} />
              </Row>
              <Typography ellipsisLine={1}>{list.title}</Typography>
            </Row>
          </Button>
        ))}
      </Column>
    </Column>
  );
};
